export default __webpack_public_path__ + "static/media/SERIES-800-8100MPNH-REMOTE-CLOSE-UP-.9d86024b.jpeg";